<template>
  <div class="app-container">
    <navigation title="专题展览"></navigation>
    <div class="app-project">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        offset="1"
      >
        <ul class="oInformation" v-for="item in list" :title="item" @click="goDetail(item.id,item.title,item.link,item.descHtml)">
          <li class="project-title">{{ item.title }}</li>
          <li class="project-title project-title-right" v-if="item.subTitle">{{ item.subTitle }}</li>
          <li class="project-img">
            <img :src="item.coverPath?baseUrl+item.coverPath:require('@/assets/img/information-img.png')" alt="">
          </li>
<!--          <li class="date">{{ item.createTime }}</li>-->
        </ul>
      </van-list>
    </div>
    <scroll></scroll>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import scroll from '../../components/scroll'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup)

export default {
  name: 'projectList',
  components: {navigation, version, scroll},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      params: {
        pageNum: '1',
        pageSize: '10'
      },
      specialList: [],
      onlineList: [],
      list: [],
      loading: false,
      finished: false,
      leaveList: []
    }
  },
  created () {
  },
  methods: {
    onLoad () {
      this.loading = true
      var url = '/nlc-web/api/special'
      this.params.type = 'SPECIAL_EXHIBITION'
      request('get', url, this.params).then(res => {
        console.log('列表', res)
        for (var i = 0; i < res.data.content.length; i++) {
          this.list.push(res.data.content[i])
        }
        // 加载状态结束
        this.loading = false
        if (res.data.totalElements === this.list.length) {
          this.finished = true
        }
      })
      this.params.pageNum++
    },
    // 去详情
    goDetail (id,title,link,descHtml) {
      if (link) {
        let params = {
          resId: id,
          resName: title,
          moduleName: '专题'
        }
        request('post', '/nlc-web/api/websiteData/res',params).then(res => {
          console.log('统计',res)
        })
        // .href = link
        window.open(link)
      } else {
        if(!descHtml){
          this.getDirectory (id)
        } else {
          this.$router.push({name: 'articleDetails', params: {id: id}})
        }
      }
    },
    getDirectory (id) {
      request('get', '/nlc-web/api/special/cataloguesAll', {}, id).then(res => {
        console.log('目录列表', res)
        this.getLeave(res.data)
        this.$router.push({name: 'articleChildDetails', query: {id: this.leaveList[0], parentId:id}})
      })
    },
    // 查找子目录第一层级
    getLeave(data){
      if(data.length>0){
        this.getLeave(data[0].subsetList)
        this.leaveList.push(data[0].id)
      }
    }
  },
  //home>projectList>articleDetails  home>projectList articleDetails>projectList
  beforeRouteLeave(to, from, next) {
    console.log('1234567')
    console.log('to.name',to)
    if (to.name === 'articleDetails') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next();//不可缺少
  },
}
</script>

<style scoped>
.app-container{
  background:#ECF5FC;
  padding-top:1.12rem;
}
.app-project{
  width:6.94rem;
  margin:0 .28rem .3rem .28rem;
  background:#fff;
  border-radius:8px;
  padding-bottom:.3rem;
}
.van-list{
  padding:.2rem .25rem;
}
.project-title{
  font-size:.3rem;
  line-height:.42rem;
  font-family: SourceHanSerifCN-Regular;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.project-img{
  width:6.43rem;
  height:2.84rem;
  margin-top:.16rem;
  background:url('../../assets/img/shadow.png') no-repeat;
  background-size:100% 100%;
}
.project-img img{
  width:6.29rem;
  height:2.6rem;
  margin-left:.09rem;
  border-radius:8px;
}
.date{
  color:#94979C;
  font-size:.2rem;
  padding:.1rem 0 .15rem 0;
}
.oInformation{
  border-bottom:1px solid #B3BBC3;
  width:6.43rem;
  margin-top:.16rem;
}
.oInformation:last-child{
  border:none !important;
}
.project-title-right{
  text-align:right;
}
</style>



// WEBPACK FOOTER //
// src/view/projectList/index.vue